export default {
  SET_NOTIFICATIONS_FOR_SYS (state, notificationsForSys) {
    state.notificationsForSys = notificationsForSys
  },
  SET_INFO_DB(state, payload){
    state.infoDB = payload
  },
  UPDATE_NOTIFICATIONS_FOR_SYS(state, payload){
    const index = state.notificationsForSys.findIndex(user => user.id == payload.id);
    state.notificationsForSys.splice(index, 1, payload)
  },
  UPDATE_READ_NOTIFICATIONS_FOR_SYS(state, payload){
    state.notificationsForSys.map((element) => {
      if (element.id === payload){
        element.read_status = 1;
      }
    });
  },
  GET_UNREAD_NOTIFICATIONS_FOR_SYS(state, countUnreadNotificationsForSys){
    state.countUnreadNotificationsForSys = countUnreadNotificationsForSys
  }
}